import { useQuery } from "@tanstack/react-query";
import {
  GroupVisitSessionControllerApi,
  GroupVisitSharedNote,
} from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

export const GROUP_NOTE_QUERY_KEY = "group-note";

/** The one note that covers every attendee of a session. */
export const useGroupNoteBySessionId = (sessionId?: string) =>
  useQuery({
    queryKey: [GROUP_NOTE_QUERY_KEY, sessionId],
    enabled: !!sessionId,
    refetchOnWindowFocus: false,
    // A session with no shared note yet answers with an error; nothing to retry.
    retry: false,
    queryFn: async () =>
      new GroupVisitSessionControllerApi(getConfigObject())
        .getGroupNote(sessionId as string, getXtenantId())
        .then(
          (res) => (res?.data?.data as GroupVisitSharedNote | null) ?? undefined
        ),
  });
